import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import Info from 'modules/documents/components/BulkFiles/DocumentAssigner/BulkAssigner/BulkModal/Info'
import LoadingFetchingBody from 'modules/documents/components/BulkFiles/DocumentAssigner/BulkAssigner/BulkModal/LoadingFetchingBody'
import MatchWithSignature from 'modules/documents/components/BulkFiles/DocumentAssigner/BulkAssigner/BulkModal/MatchWithSignature'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'
import type { AssignEsignatureForm } from 'modules/documents/lib/forms/AssignEsignatureForm'
import Loading from 'modules/layout/components/Page/Loading'

interface Props {
  selectedIdsForEsignature: string[]
  requestEsignatureForm: AssignEsignatureForm
  uploadProcess: UploadProcess
  onSelectIdsForEsignature: (arg0: string[]) => void
  onClose: () => void
  onClick: () => void
  isLoading: boolean
  isFetchingScores: boolean
  countMatches: number
  remainingDocs: number
}

const BulkModal = ({
  selectedIdsForEsignature,
  requestEsignatureForm,
  uploadProcess,
  onSelectIdsForEsignature,
  onClick,
  onClose,
  isLoading,
  isFetchingScores,
  countMatches,
  remainingDocs,
}: Props) => {
  const signatureRequested = uploadProcess?.esignatureRequest ?? false

  return (
    <Modal
      illustration="common-file-text-upload"
      title={i18n.t('split_documents.bulk_modal.title_v2')}
      description={i18n.t('split_documents.bulk_modal.description_v2')}
      onClose={onClose}
      footer={
        <>
          {isLoading && (
            <Button.Decorative type="primary" disabled>
              {i18n.t('split_documents.assign_documents.distribute')}
            </Button.Decorative>
          )}
          {!isLoading && !isFetchingScores && countMatches === 0 && (
            <Button type="secondary" onClick={onClose}>
              {i18n.tp('split_documents.bulk_modal.remaining_documents', {
                count: 0,
              })}
            </Button>
          )}
          {!isLoading && countMatches > 0 && (
            <Button type="secondary" onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>
          )}
          {!isLoading && !isFetchingScores && countMatches > 0 && (
            <Button type="primary" onClick={onClick}>
              {i18n.t('split_documents.assign_documents.distribute')}
            </Button>
          )}
        </>
      }
    >
      {isFetchingScores && !isLoading && <LoadingFetchingBody />}
      {isLoading && <Loading />}
      {!isLoading && !isFetchingScores && (
        <Box width="s400">
          <Info
            countMatches={countMatches}
            remainingDocs={remainingDocs}
            signatureRequested={signatureRequested}
          />
          {signatureRequested && (
            <MatchWithSignature
              selectedIdsForEsignature={selectedIdsForEsignature}
              requestEsignatureForm={requestEsignatureForm}
              uploadProcess={uploadProcess}
              onSelectIdsForEsignature={onSelectIdsForEsignature}
              countMatches={countMatches}
              remainingDocs={remainingDocs}
            />
          )}
        </Box>
      )}
    </Modal>
  )
}

export default BulkModal
